import Swiper from 'swiper/dist/js/swiper.js';

export default {
  init() {
    var sliderTimeVar = new sliderTime('.homeslider-container');

    function fixHeight() {
      var heightContainer = jQuery(window).height() - jQuery('.nav-container').outerHeight() - jQuery('footer').outerHeight();
      jQuery('main').css('height', heightContainer);
      jQuery('.homeslider-container').css('height', heightContainer - 20);
      jQuery('.swiper-wrapper').css('margin', '10px auto ' + (jQuery(window).height() + 10) + ' !important');

      if(sliderTimeVar.isInitOne) {
        if (sliderTimeVar.homeSlider && typeof sliderTimeVar.homeSlider == 'object' && sliderTimeVar.homeSlider.initialized) {
          sliderTimeVar.homeSlider.update();
        } else if (sliderTimeVar.homeSlider && typeof sliderTimeVar.homeSlider == 'object') {
          sliderTimeVar.homeSlider.init();
          let elements = document.querySelectorAll('[data-responsive-background-image], [data-responsive-large-background-image], [data-responsive-extralarge-background-image]');
          for (let i=0; i<elements.length; i++) {
            new ResponsiveBackgroundImage(elements[i]);
          }
        }
      }
    }

    /**
     * Get the value of a querystring
     * @param  {String} field The field to get the value of
     * @param  {String} url   The URL to get the value from (optional)
     * @return {String}       The field value
     */
    var getQueryString = function ( field, url ) {
      var href = url ? url : window.location.href;
      var reg = new RegExp( '[?&]' + field + '=([^&#]*)', 'i' );
      var string = reg.exec(href);
      return string ? string[1] : null;
    };

    jQuery( document ).ready(function() {
      var currentURL = window.location.href.split('?')[0];
      var hash = currentURL.split('#')[1];

      sliderTimeVar.startSlider();
      if(hash == 'prooftag' && getQueryString('code') != null ) {
        var dfd = $.Deferred();

        // Add handlers to be called when dfd is resolved
        dfd
        // .done() can take any number of functions or arrays of functions
          .done( jQuery('.nav-icon').trigger('click'), jQuery('#menu-principal, #pro, #prooftag, #mentions-legales').removeClass('active'), jQuery('#prooftag').addClass('active'), jQuery(".main-menu").animate({ scrollTop: 0 }, "slow"), jQuery('#form-prooftag').find('input[name=tag]').val(getQueryString('code')) )
        // We can chain done methods, too
          .done(function( ) {
            jQuery('#form-prooftag').submit();
          });

        // Resolve the Deferred object when the button is clicked
        dfd.resolve( "and" );
      }
    });

    jQuery('.home-container').on('click', function() {
      jQuery('.nav-icon').trigger('click');
    });

    jQuery('.nav-icon').on('click', function() {
      if (jQuery(this).hasClass('animate-icon')) {
        if (sliderTimeVar.homeSlider && typeof sliderTimeVar.homeSlider == 'object' && sliderTimeVar.homeSlider.initialized) {
          sliderTimeVar.endSlider(true);
        }
      } else {
        if (sliderTimeVar.homeSlider && typeof sliderTimeVar.homeSlider == 'object' && !sliderTimeVar.homeSlider.initialized) {
          sliderTimeVar.startSlider();
        }
      }
    });

    jQuery(window).on("resize orientationchange", function () {
      fixHeight();
    });
    fixHeight();
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};

export class sliderTime {
  constructor(element) {
    this.element = element;
    this.startSliderTime = null;
    this.endSliderTime = null;
    this.homeSlider = null;
    this.isInitOne = false;
    //console.log('CONSTRUCTOR'); //eslint-disable-line
  }

  endSlider(instant = false) {
    if(this.startSliderTime){
      clearTimeout(this.startSliderTime);
    }
    var timer = 3000;
    if(instant) {
      timer = 0
    }
    var self = this;

    this.endSliderTime = setTimeout(function() {
      jQuery(self.element).removeClass('active');
      jQuery(self.element).parent('.home-container').removeClass('active-slideshow');
      jQuery('#homepage-std').fadeIn(600);

      setTimeout(function() {
        if (self.homeSlider && typeof self.homeSlider == 'object' && self.homeSlider.initialized) {
          self.homeSlider.destroy();
        }
      }, 300);

    }, timer);
  }

  startSlider() {
    if(this.endSliderTime){
      clearTimeout(this.endSliderTime);
    }

    var self = this;
    this.homeSlider = new Swiper(this.element, {
      init: false,
      initialSlide: 0,
      autoplay: {
        delay: 5000,
      },
      loop: false,
      effect: 'fade',
      slidesPerView: '1',
      centeredSlides: true,
      spaceBetween: 0,
      preloadImages: true,
      simulateTouch: false,
      speed: 1500,
      keyboard: {
        enabled: true,
      },
      on: {
        init: function() {
          this.isInitOne = true;
          jQuery('#homepage-std').fadeOut(100);
        },
        reachEnd: function() {
          setTimeout(function() {
            self.endSlider();
            if (!jQuery('body').hasClass('active-menu')) {
              jQuery('.nav-icon').trigger('click');
            }
          }, 6500);

        },
      },
    });

    this.startSliderTime = setTimeout(function() {
      jQuery(self.element).addClass('active');
      jQuery(self.element).parent('.home-container').addClass('active-slideshow');


      setTimeout(function() {
        if (self.homeSlider && typeof self.homeSlider == 'object' && !self.homeSlider.initialized) {
          self.homeSlider.init();
        }
      }, 200);
    }, 7500);
  }
}

export class ResponsiveBackgroundImage {
  constructor(element) {
      this.element = element;
      this.img = element.querySelector('img');
      this.src = '';

      if(this.img != null) {
        this.img.addEventListener('load', () => {
          this.update();
        });

        if (this.img.complete) {
            this.update();
        }
      }
  }

  update() {
      let src = typeof this.img.currentSrc !== 'undefined' ? this.img.currentSrc : this.img.src;
      if (this.src !== src) {
          this.src = src;
          this.element.style.backgroundImage = 'url("' + this.src + '")';
      }
  }
}



// WEBPACK FOOTER //
// ./scripts/routes/home.js